import React, { useState } from 'react'

import axios from 'axios'
import { useIntervalWhen } from 'rooks'

export const DownloadButton = ({ uuid }: {uuid: string}) => {
  const [doPoll, setDoPoll] = useState(false)
  const [elapsedTime, setElapsedTime] = useState<number>()
  const [error, setError] = useState<string>()
  const [isPending, setIsPending] = useState(false)

  const prepareDownload = async () => {
    setIsPending(true)
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_HOST}/download/prepare/${uuid}`)
      if (response.data.submitstatus !== 'success') throw Error()
      startPolling()
    } catch (ex) {
      setError('Apologies, the file preparation failed. Our web team has been informed. Please try later.')
      setIsPending(false)
    }
  }

  const startPolling = () => {
    setElapsedTime(undefined)
    setDoPoll(true)
  }

  useIntervalWhen(
    () => {
      const time = elapsedTime === undefined ? 0 : elapsedTime + 1
      if (time % 5 === 0) {
        checkDownload()
      }
      if (time >= 151) {
        setError('Apologies, the file preparation failed. Our web team has been informed. Please try later.')
        setDoPoll(false)
        setIsPending(false)
      }
      setElapsedTime(time)
    },
    1000,
    doPoll,
    true
  )

  const checkDownload = async () => {
    const response: any = await axios.post(`${process.env.REACT_APP_API_HOST}/download/check/${uuid}`)
    if (response.data.status === 'ready') {
      if (response.data.filename) {
        window.location.href = `${process.env.REACT_APP_WEB_HOST}/data/published_data_library/catalogue/10.5285/123/${response.data.filename}`
        setDoPoll(false)
        setIsPending(false)
      }
    } else if (response.data.status !== 'notready') {
      setError('ERROR')
      setDoPoll(false)
      setIsPending(false)
    }
  }

  return (
    <>
      <button className='styledButton' onClick={prepareDownload} disabled={isPending}>
        Download
      </button>
      {doPoll && elapsedTime !== undefined &&
        <div>
          Preparing file. Elapsed time is {elapsedTime} seconds.
        </div>
      }
      {error && <div>{error}</div>}
    </>
  )
}
